'use client';
import React, { useState } from 'react';
import { ChevronDown, MapPin, Calendar, Check } from 'lucide-react';

import { useEvent } from '@/contexts/EventContext';

export default function EventSelector() {
  const { selectedEvent, setSelectedEvent, allEvents } = useEvent();
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-3 py-2 rounded-lg border border-border bg-card hover:bg-muted transition-colors text-sm font-medium text-foreground"
      >
        <MapPin size={14} className="text-primary flex-shrink-0" />
        <span className="hidden sm:inline">{selectedEvent?.name}</span>
        <span className="sm:hidden">{selectedEvent?.city}</span>
        <ChevronDown size={14} className={`text-muted-foreground transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="absolute top-full left-0 mt-1 w-64 bg-card border border-border rounded-xl shadow-lg z-50 overflow-hidden fade-in">
          <div className="px-3 py-2 border-b border-border">
            <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">MPS Veranstaltungen 2026</p>
          </div>
          {allEvents?.map(event => (
            <button
              key={event?.id}
              onClick={() => { setSelectedEvent(event); setOpen(false); }}
              className={`w-full flex items-start gap-3 px-3 py-2.5 hover:bg-muted transition-colors text-left ${
                selectedEvent?.id === event?.id ? 'bg-primary/5' : ''
              }`}
            >
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="font-semibold text-sm text-foreground">{event?.name}</span>
                  {selectedEvent?.id === event?.id && <Check size={13} className="text-primary flex-shrink-0" />}
                </div>
                <div className="flex items-center gap-1 mt-0.5">
                  <Calendar size={11} className="text-muted-foreground" />
                  <span className="text-xs text-muted-foreground">{event?.dates}</span>
                </div>
                <p className="text-xs text-muted-foreground truncate">{event?.location}</p>
              </div>
            </button>
          ))}
        </div>
      )}
      {open && (
        <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
      )}
    </div>
  );
}
